import { cn } from '../../../utils/common-utils.ts';
import ForReviewFlagIcon from '../../common/icons/for-review-flag-icon.tsx';

interface IProps {
  isMark: boolean;
  toggleMark?: () => void;
}

const MarkButton = ({ isMark, toggleMark }: IProps) => (
  <button
    type="button"
    className={cn(
      'inline-flex items-center gap-1.5 text-[0.9rem] text-black transition-all',
      isMark
        ? 'font-semibold underline underline-offset-2 hover:font-normal'
        : 'font-normal hover:font-semibold',
    )}
    onClick={toggleMark}
  >
    <ForReviewFlagIcon className="h-[22px] w-[22px]" filled={isMark} />
    <span>Mark for Review</span>
  </button>
);

export default MarkButton;
